import React from 'react';
import { NSSelect } from 'bricks';
import { customStyles } from 'bricks/NSSelect/NSSelect';
import { IOptionAnyValue } from 'bricks/types';

interface UnitTypeHeaderProps {
    options: IOptionAnyValue[];
    selectedType: string;
    onTypeChange: (value: string) => void;
}

const UnitTypeHeader: React.FC<UnitTypeHeaderProps> = ({ options, selectedType, onTypeChange }) => (
    <div className="d-flex align-items-center">
        <span className="mr-1">$ /</span>
        <NSSelect
            name="unit-type"
            options={options}
            value={options.find(opt => opt.value === selectedType)}
            onChange={option => onTypeChange(option?.value || '')}
            isClearable={false}
            menuPosition="fixed"
            small
            styles={{
                ...customStyles,
                control: (provided: any, state: any) => ({
                    ...provided,
                    backgroundColor: '#f1f1f12e',
                    color: '#f1f1f1',
                    minHeight: '24px',
                    height: '24px',
                    padding: '0 4px',
                    marginTop: '2px',
                    border: 'none',
                    '&:hover': {
                        backgroundColor: '#f1f1f140',
                    },
                }),
                singleValue: (provided: any) => ({
                    ...provided,
                    color: '#f1f1f1',
                }),
                menuList: (provided: any) => ({
                    ...provided,
                    maxHeight: '150px',
                }),
            }}
        />
    </div>
);

export default UnitTypeHeader;
